export default [
  {
    time: '9:30-9:40',
    title: '开场致辞',
    guests: [
      {
        name: '李凯',
        position: '每日经济新闻副总编辑、天府文投董事长'
      }
    ]
  },
  {
    time: '9:40-10:00',
    title: '主旨演讲一<br>绿色新基建，PE/VC大有可为',
    guests: [
      {
        name: '李守宇',
        position: '深创投集团副总裁'
      }
    ]
  },
  {
    time: '10:00-10:20',
    title: '主旨演讲二<br>“碳中和”推动私募股权投资回归服务实体经济本源',
    guests: [
      {
        name: '姜燕',
        position: '盛世投资首席可持续发展官、合伙人'
      }
    ]
  },
  {
    time: '10:20-11:20',
    title: '圆桌对话<br>广阔的碳中和赛道，投资机构面临哪些机会与挑战？',
    guests: [
      {
        name: '主持人 ——'
      },
      {
        name: '任飞',
        position: '每日经济新闻资深记者'
      },
      {
        name: '嘉宾 ——'
      },
      // {
      //   name: '徐诗',
      //   position: '山行资本创始合伙人'
      // },
      {
        name: '金天',
        position: '昆仑万维董事长、昆仑资本管理合伙人'
      },
      {
        name: '陈宇雷',
        position: '盈科资本合伙人'
      },
      {
        name: '熊钢',
        position: '澳银资本董事长'
      },
      {
        name: '袁锋',
        position: '广汽资本总经理'
      }
    ]
  },
  {
    time: '11:20-11:30',
    title: '每经2021投资机构品牌价值榜发布',
    subTitle: ' '
  }
];
